import FormMutationTypes from './FormMutationTypes';
import FormService from '../service/FormService';

async function loadTemplates({ commit }) {
  commit(FormMutationTypes.UPDATE_LOADING_STATE, true);
  try {
    const templates = await FormService.listTemplates();
    commit(FormMutationTypes.UPDATE_TEMPLATES, templates);
  } finally {
    commit(FormMutationTypes.UPDATE_LOADING_STATE, false);
  }
}

function updateForms({ commit }, forms) {
  commit(FormMutationTypes.UPDATE_FORMS, forms);
}

function updateFormsToBeRemoved({ commit }, formsToBeRemoved) {
  commit(FormMutationTypes.UPDATE_FORMS_TO_BE_REMOVED, formsToBeRemoved);
}

async function loadByWorkOrder({ commit }, workOrderId) {
  if (workOrderId === null) {
    return commit(FormMutationTypes.UPDATE_FORMS, []);
  }
  const forms = await FormService.listByWorkOrders([workOrderId]);
  return commit(FormMutationTypes.UPDATE_FORMS, forms);
}

async function remove({ commit, state }, form) {
  await FormService.remove(form);
  const forms = state.forms.filter((existingForm) => existingForm !== form);
  commit(FormMutationTypes.UPDATE_FORMS, forms);
}

const FormActions = {
  remove,
  loadTemplates,
  updateForms,
  updateFormsToBeRemoved,
  loadByWorkOrder,
};

export default FormActions;
